module.exports = __webpack_public_path__ + "static/media/icon.2ceaf661.svg";